var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{attrs:{"color":"red","size":"28"}},[_vm._v("mdi-alarm")]),_c('div',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm.dataUnit.reminder.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }